module.exports = __webpack_public_path__ + "img/sign-in.6d6d6c12.png";